import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';

const Signup = () => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await signup(data.email, data.password, { name: data.name, phone: data.phone });
      toast.success('Account created!');
      navigate('/login');
    } catch (error) {
      toast.error(error.message || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full card p-8">
        <h1 className="text-3xl font-bold mb-6 text-center">Create Account</h1>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="block font-semibold mb-2">Name</label>
            <input {...register('name', { required: true })} className="input" />
          </div>
          <div>
            <label className="block font-semibold mb-2">Email</label>
            <input type="email" {...register('email', { required: true })} className="input" />
          </div>
          <div>
            <label className="block font-semibold mb-2">Phone</label>
            <input {...register('phone', { required: true })} className="input" />
          </div>
          <div>
            <label className="block font-semibold mb-2">Password</label>
            <input type="password" {...register('password', { required: true, minLength: 6 })} className="input" />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary w-full">
            {loading ? 'Creating...' : 'Sign Up'}
          </button>
        </form>
        <p className="text-center mt-4"><Link to="/login" className="text-primary">Already have an account?</Link></p>
      </div>
    </div>
  );
};

export default Signup;
